import React from "react";
import { Button, Col, Dropdown, Row } from "react-bootstrap";
import { AccountSelectionType, CSVStatusHeading, UserInviteMap, UserValidationState, UserValidationType } from "src/common";
import { Icon } from "src/components";
import _ from "lodash";

type AllProps = {
  csv_data_hash: UserInviteMap;
  validation_state: UserValidationType;
  collection: string[];
  deleteFunction: Function;
  onAccountTypeChange?: (user_id: string, type: AccountSelectionType) => void;
};

// Description: Displays the different tables of the CSV upload card. (Valid, Invalid, Duplicate, etc)
function CSVInvitesDisplayComponent(props: AllProps) {
  const { csv_data_hash, validation_state, collection, deleteFunction, onAccountTypeChange } = props;
  const heading_text = CSVStatusHeading[validation_state];
  const heading = collection.length === 1 ? heading_text.replace("Accounts", "Account") : heading_text;

  return <div className="table-display">
    <Row className="header-card-row ">
      <h5 className="m-0">{`${collection.length} ${heading}`}</h5>
    </Row>
    <div className="table-body">
      {_.map(collection, (user_id: string, index: number) => {
        const _user = csv_data_hash[user_id];
        const is_valid = validation_state !== UserValidationState.invalid && validation_state !== UserValidationState.duplicate;
        return <Row key={index}>
        <Col xs={4}>
          <p className="semi-bold">{`${_user.first_name} ${_user.last_name}`}</p>
          <p>{_user.email || user_id}</p>
        </Col>
        <Col xs={3}>
          <p className="m-0">{_user.department}</p>
        </Col>
        <Col xs={4}>
          {is_valid && validation_state === UserValidationState.valid_external &&<Dropdown className="d-block pv-dropdown">
            <Dropdown.Toggle 
              variant="link" 
              className={`pv-dropdown text-start`}
            >
              {_user.account_type === "full" ? "Full Account" : _user.account_type === "express" ? "Express Account" : "Account Type"}
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item onClick={() => onAccountTypeChange?.(user_id, "full")}>Full Account</Dropdown.Item>
              <Dropdown.Item onClick={() => onAccountTypeChange?.(user_id, "express")}>Express Account</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>}
        </Col>
        {is_valid &&
        <Col xs={1}>
          <Button 
            variant="icon"
            size="sm"
            aria-label="Delete User"
            onClick={() => deleteFunction(user_id)}
          >
            <Icon className="ficon-x" />
          </Button>
        </Col>}
      </Row>;
      })}
    </div>
  </div>;
}

export default React.memo(CSVInvitesDisplayComponent);